import { j as t } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import o from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-CQds873Z.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as m } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/Education.css';const p = "_list_1bmn4_1", s = {
  "list-wrapper": "_list-wrapper_1bmn4_1",
  list: p
};
function h(l) {
  const {
    editable: i,
    education: r
  } = l;
  return /* @__PURE__ */ t(m, {
    onEditClick: i != null && i.isEditable ? i.onEditEducation : void 0,
    title: o("SUB_PROFILE_EDUCATION_HEADER"),
    children: /* @__PURE__ */ t("div", {
      children: r && r.length > 0 ? /* @__PURE__ */ t("ul", {
        className: s["list-wrapper"],
        children: r.map((n) => /* @__PURE__ */ t("li", {
          className: s.list,
          children: n.name
        }, n.id))
      }) : /* @__PURE__ */ t("span", {
        style: {
          fontStyle: "italic"
        },
        children: i != null && i.isEditable ? o("SUB_PROFILE_EDUCATION_EDIT_EMPTY") : o("SUB_PROFILE_NO_INFORMATION")
      })
    })
  });
}
export {
  h as Education
};
